/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import IFlujos from 'Infotrack@Modelos/smartStock/flujos/entidades/flujos';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorIndicadorCargaGlobal,
    manejadorDialogoGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FlujosCM from '../controladorModelo/flujosCM';
import { acciones, IEstadoFlujos } from '../reductorFlujos';
import FlujosVista from '../vista/tablaFlujosVista';
import Texto from '@infotrack/presentacion-componentes/texto';

const flujosCM = new FlujosCM();

const TableFlujosCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [flujoss, setFlujoss] = React.useState<IFlujos[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoFlujos>();

    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarFlujos();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarFlujos = () => {
        manejadorIndicadorCargaGlobal(true);
        flujosCM.consultarFlujos().then((flujoss) => {
            //setFlujoss(flujoss);manejadorIndicadorCargaGlobal(false);
        });
    };
    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadFlujos?: IFlujos) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadFlujos, tipoFormulario } });
    };

    const confirmarEliminacion = (flujos: IFlujos) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarFlujos(flujos),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const eliminarFlujos = (flujos: IFlujos) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        flujosCM.eliminarFlujos(flujos).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <FlujosVista
            flujoss={flujoss}
            cargarFlujos={cargarFlujos}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableFlujosCV;
